import Icon from 'components/Icon';
import Image from 'components/Image';
import WithScroll from 'hocs/WithScroll';

const AboutSiteplus = props => (
  <article className="section__article section__article_tab_1">
    <section className="section section_about-sp_1">
      <div className="wrapper">
        <div className="row">
          <div className="col col-7 col-tablet-12">
            <div className="_mb-tablet-60 _mb-note-34">
              <h2 className="title title_size_m section__title _mb-18">
                Our Story
              </h2>
              <p className="text _mb-16">
                Welcome to Siteplus, the new on-ramp for going online. We're
                dedicated to providing the very best technology platform for
                building beautiful websites with an emphasis on simplicity and
                delightful user-experiences.
              </p>
              <p className="text _mb-16">
                Founded in 2015, Siteplus has come a long way in creating our
                best-in-class white-label website builder for hosting companies,
                domain registrars, telcos, and agencies.
              </p>
              <p className="text _mb-16">
                With nearly 20 years of corporate experience in the domain and
                web hosting industries, we discovered a huge need in the market.
                After implementing several website builders, it became clear
                that commercial website builders were too complex, difficult to
                use, and expensive to support. Our platform is simply better!
              </p>
              <p className="text">
                Siteplus is a sticky, high-retention solution that exceeds
                expectations from providers and users alike. Our partners
                experience substantial increases in conversions, renewals, and
                customer satisfaction scores.
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-12 offset-1 offset-tablet-0">
            <div className="section__image-wrap">
              <Image className="section__image" src="img-162.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_about-sp_2">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <h2 className="title section__title _mb-1">The Vision</h2>
            <div className="section__blockquote">
              <Icon className="section__blockquote-icon" icon="icon-95" />
              <p className="section__blockquote-text">
                To create and continually enhance a technology platform that
                simplifies the process of designing and building an online
                presence.
              </p>
            </div>
          </div>
          <div className="col col-6 col-tablet-12">
            <h2 className="title section__title _mb-1 _mt-tablet-40">
              The Mission
            </h2>
            <div className="section__blockquote">
              <Icon className="section__blockquote-icon" icon="icon-95" />
              <p className="section__blockquote-text">
                To deliver stable, scalable, simple and attractive website
                technology solutions for anyone, anywhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_about-sp_3">
      <div className="wrapper">
        <div className="row">
          <div className="col col-4 col-tablet-12">
            <div className="section__image-wrap _mb-tablet-60 _mb-note-34">
              <Image className="section__image" src="img-163.jpg" />
            </div>
          </div>
          <div className="col col-7 offset-1 col-tablet-12 offset-tablet-0">
            <div className="_mb-tablet-40">
              <h2 className="title title_size_m section__title _mb-18">
                Our People
              </h2>
              <p className="text _mb-16">
                We're a team of 70 passionate people developing and supporting
                the most efficient and easy-to-use Website Builder. Our head
                office is located in Singapore, while our core development
                office is in Ukraine.
              </p>
              <p className="text _mb-65 _mb-note-34">
                We enjoy pushing the limits of complex website functionalities
                to offer simpler solutions to our customers. Our goal is to give
                our customers easy-to-use functions to create modern websites
                with a click.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
);

export default WithScroll(AboutSiteplus);
